var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVkSettingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.468 0H8.732C1.673 0 0 1.673 0 8.732v7.736C0 23.527 1.673 25.2 8.732 25.2h7.736c7.059 0 8.732-1.673 8.732-8.732V8.732C25.2 1.673 23.51 0 16.468 0zm3.876 17.977h-1.83c-.693 0-.906-.55-2.153-1.813-1.082-1.05-1.562-1.19-1.829-1.19-.377 0-.484.107-.484.624v1.653c0 .444-.14.71-1.313.71-1.94 0-4.093-1.174-5.603-3.36-2.276-3.203-2.9-5.603-2.9-6.099 0-.267.107-.516.62-.516h1.833c.464 0 .64.213.82.71.907 2.616 2.416 4.908 3.04 4.908.23 0 .335-.106.335-.693V10.21c-.07-1.247-.726-1.354-.726-1.796 0-.214.177-.427.46-.427h2.882c.39 0 .534.213.534.672v3.646c0 .394.176.533.282.533.23 0 .427-.139.853-.566 1.317-1.476 2.26-3.753 2.26-3.753.123-.267.337-.516.8-.516h1.834c.55 0 .672.282.55.676-.23 1.066-2.474 4.233-2.474 4.233-.193.32-.267.459 0 .816.197.266.837.82 1.263 1.316.783.89 1.386 1.637 1.547 2.153.18.513-.086.78-.604.78h.003z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVkSettingIcon);
export default __webpack_public_path__ + "static/media/vk-setting-icon.6ef2b99b9fcb3b81a026b2fba8abb744.svg";
export { ForwardRef as ReactComponent };